import { createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() =>
  createStyles({
    dialogPaperPropsRoot: {
        position: 'absolute',
        left: '2%',
        bottom: '2%'
    
    },
  }),
);
